<template lang='pug'>
    #customer-historic
        r-table(
            loading-text='Cargando documentos históricos...'
            no-data-text='Sin documentos históricos.'
            no-search
            no-remove
            ref='table'
            v-bind='tableProps'
            @detail='submitShow'
        )
            template( slot='actions' slot-scope='props' )
                r-btn-action( 
                    color='dark'
                    tooltip='PDF'
                    @click='submitPdf(props)' 
                )
                    v-icon picture_as_pdf
        detail-dialog(
            :invoice-id='invoiceId'
            read-only
            ref='invoiceReceivableDialog'
        )
</template>

<script>
    //
    import { RBtnAction, RTable } from '@/components/reusable_components/next'
    //
    import SaleInvoiceModel from '@/models/Sale/SlSaleInvoice'
    import SlTaxDocumentMdl from '@/models/Sale/SlTaxDocument.js'
    //import TableHeaders from './headers/historicTaxDocument'
    import DetailDialog from '@/components/dialogs/invoice/InvoiceDetailDialog'
    import TableHeaders from '@/views/customer/tables/customerReceivableInvoice/Headers.js'
    //
    export default {
        name: 'customer-historic-invoice',
        components: {
            RBtnAction,
            RTable,
            'detail-dialog': DetailDialog,
        },
        data() {
            return {
                headerTable: TableHeaders,
                filters: [
                    {
                        name: 'dte_number',
                        props: {
                            label: 'Folio',
                        },
                        flex: {
                            sm6: true,
                            lg5: true,
                        },
                        type: 'text-field',
                    },
                ],
                customerId: null,
                invoiceId: null,
            }
        },
        computed: {
            tableProps() {
                return {
                    service: SaleInvoiceModel,
                    paramFilter: {
                        sl_customer_id: this.customerId,
                    },
                    headers: this.headerTable,
                    filters: this.filters,
                }
            },
        },
        methods: {

            /**
             */
            setCustomerId() {
                this.customerId = this.$route.params.id
            },

            /**
             * Shows the pdf.
             *
             * @param      {object}  model   The model
             */
            showPdf(model) {
                return model.toPdf()
            },

            /**
             * @description
             * Print sale invoice PDF
             *
             * @param      {object}  event   The event
             * @return     {object}  blob file
             */
            submitPdf(event) {
                switch(event.item.dte_type) {
                    case 33: event.item.fetchSaleInvoice().then(this.showPdf)
                }
            },

            /**
             *
             */
            submitShow(event) {
                this.invoiceId = event.item.id
                this.$refs.invoiceReceivableDialog.open = true
            },
        },
        beforeMount() {
            this.setCustomerId()
        },
    }
</script>

